<template>
  <div>
    <v-tabs show-arrows="always" color="primary" right background-color="transparent">
      <v-tabs-slider color="primary"></v-tabs-slider>

      <v-tab> <v-icon left> mdi-video-input-hdmi </v-icon>{{ $t("userInterface.headers.io") }}</v-tab>
      <v-tab> <v-icon left> mdi-tune-variant </v-icon>{{ $t("userInterface.headers.parameters") }}</v-tab>
      <v-tab> <v-icon left> mdi-power </v-icon>{{ $t("userInterface.headers.control") }}</v-tab>

      <!-- Vstupy a výstupy -->
      <v-tab-item class="ma-2">
        <template v-if="this.external != null">
          <v-row dense>
            <v-col cols="12">
              <h2>{{ $t("externalio.header1") }}</h2>
            </v-col>
          </v-row>

          <v-row dense justify="space-around">
            <v-col cols="11">
              <v-row dense>
                <v-col cols="12">
                  <h4>{{ $t("externalio.inputs") }}</h4>
                  <v-btn class="ma-1 ma-0 pa-0" :style="isNotActive('outputs', index - 1) == true ? '' : 'color: white'" small v-for="index in 4" :key="index + 'IN'" :color="getColor('inputs', index - 1)" elevation="2" :outlined="isNotActive('inputs', index - 1)">
                    {{ itemsSetNameInput[index - 1].name != "" ? itemsSetNameInput[index - 1].name : index }}
                  </v-btn>
                  <br />
                </v-col>
                <v-col cols="12">
                  <h4>{{ $t("externalio.outputs") }}</h4>
                  <v-btn class="ma-1 ma-0 pa-0" :style="isNotActive('outputs', index - 1) == true ? '' : 'color: white'" small v-for="index in 4" :key="index + 'OUT'" :color="getColor('outputs', index - 1)" elevation="2" :outlined="isNotActive('outputs', index - 1)" @click="toggleOutput(index)">
                    {{ itemsSetNameOutput[index - 1].name != "" ? itemsSetNameOutput[index - 1].name : index }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1" align="end">
              <v-icon :color="showIOSettings == 1 ? 'primary' : 'grey'" @click="collapseInputOutputDown" dark> mdi-grease-pencil </v-icon>
            </v-col>
          </v-row>

          <v-row dense>
            <template v-if="showIOSettings == 1">
              <template v-if="itemsSetNameInput.length != 0 && itemsSetNameOutput.length != 0">
                <v-col cols="12">
                  <h4>{{ $t("externalio.setInputName") }}</h4>
                </v-col>
                <v-col cols="6" md="3" v-for="(item, index) in itemsSetNameInput" :key="index + 'SETNAMEIN'"> <b></b> <v-text-field dense outlined :label="$t('externalio.input') + ': ' + index" v-model="item.name" @change="changeIOName('IN', index, item.name)"> </v-text-field> </v-col>
                <v-col cols="12">
                  <h4>{{ $t("externalio.setOutputName") }}</h4>
                </v-col>
                <v-col cols="6" md="3" v-for="(item, index) in itemsSetNameOutput" :key="index + 'SETNAMEOUT'"> <b></b> <v-text-field dense outlined :label="$t('externalio.output') + ': ' + index" v-model="item.name" @change="changeIOName('OUT', index, item.name)"> </v-text-field> </v-col>

                <v-col cols="3">
                  <v-hover v-slot="{ hover }">
                    <v-btn :small="true" :plain="true" @click="saveNames">
                      <v-row justify="center">
                        <v-col cols="auto" class="d-flex justify-center" align="center">
                          <v-icon :elevation="hover ? 12 : 0" :color="hover ? 'primary' : 'secondary'"> mdi-floppy </v-icon>
                        </v-col>
                        <v-col cols="auto" class="d-flex mt-1 justify-center" align="center">
                          <span> {{ $t("externalio.save") }} </span>
                        </v-col>
                      </v-row>
                    </v-btn>
                  </v-hover>
                </v-col>
              </template>
            </template>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <h2>{{ $t("externalio.header2") }}</h2>

              <i class="text-caption">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-icon color="primary">mdi-help</v-icon>
                      {{ $t("externalio.help") }}
                    </span>
                  </template>
                  <span class="text-caption font-italic">
                    <b>a) {{ $t("externalio.basedOnOverflows") }} </b> {{ $t("externalio.isWorkingFrom") }} <b>42.11.</b> {{ $t("externalio.ccu") }} {{ $t("externalio.fromVersion") }} <b>42.8.</b> {{ $t("externalio.inverter") }} <b> {{ $t("externalio.settingBasicInfo") }}</b> <br />
                    <b>b) {{ $t("externalio.basedSOC") }} </b> {{ $t("externalio.isWorkingFrom") }} <b>42.13.</b> {{ $t("externalio.ccu") }} {{ $t("externalio.fromVersion") }} <b>42.11.</b> {{ $t("externalio.inverter") }} <b> {{ $t("externalio.settingBasicInfo") }}</b>

                    <br />
                    <br />
                    {{ $t("externalio.information1") }}<br />
                    {{ $t("externalio.information2") }}<br />
                    {{ $t("externalio.information3") }} <br />
                  </span>
                </v-tooltip>
              </i>
            </v-col>
          </v-row>

          <v-row class="my-border-purple" dense>
            <v-col cols="12" md="3" sm="4" align="center" class="mt-6">
              <v-chip color="purple" outlined>
                <b>
                  {{ $t("externalio.output") }}
                  1
                  {{ isExternalIO1Enabled ? $t("externalio.autoMode") : $t("externalio.manualMode") }}
                </b>
              </v-chip>
            </v-col>

            <v-col cols="12" md="auto" sm="4" class="mx-2" v-for="(item, index) in parameter.inv.ExternalIO_1_Enabled" :key="index + '1A'">
              <v-switch dense v-model="item.parameterValue" @change="sendValueSwitch(item)" :label="getLabel(item)" color="primary" :hint="$t('externalio.example') + $t('externalio.on')" persistent-hint> </v-switch>
            </v-col>

            <v-col cols="12" md="auto" sm="4" class="mx-2" v-for="(item, index) in parameter.inv.ExternalIO_1_SOCInsteadOfPowerEnabled" :key="index + '1F'">
              <v-switch dense v-model="item.parameterValue" @change="sendValueSwitch(item)" :label="getLabel(item)" color="primary" :disabled="isExternalIO1Enabled" :hint="$t('externalio.controlBasedOnPowerOrSOC')" persistent-hint> </v-switch>
            </v-col>
          </v-row>

          <v-row class="my-border-purple" dense>
            <v-col cols="12" md="2" sm="6" offset-md="3" v-for="(item, index) in parameter.inv.ExternalIO_1_PLockIn" :key="index + '1B'">
              <v-text-field
                @focus="stopTimerParameters"
                v-model="item.parameterValue"
                @change="sendValue(item)"
                type="number"
                :label="getLabel(item)"
                :disabled="isExternalIO1Enabled"
                :hint="$t('externalio.example') + (isExternalIO1SOCInsteadOfPowerEnabled ? '95 %' : '-2000 W')"
                persistent-hint
                :suffix="isExternalIO1SOCInsteadOfPowerEnabled ? '%' : 'W'"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6" v-for="(item, index) in parameter.inv.ExternalIO_1_PLockOut" :key="index + '1C'">
              <v-text-field
                @focus="stopTimerParameters"
                v-model="item.parameterValue"
                @change="sendValue(item)"
                type="number"
                :label="getLabel(item)"
                :disabled="isExternalIO1Enabled"
                :hint="$t('externalio.example') + (isExternalIO1SOCInsteadOfPowerEnabled ? '85 %' : '200 W')"
                persistent-hint
                :suffix="isExternalIO1SOCInsteadOfPowerEnabled ? '%' : 'W'"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6" v-for="(item, index) in parameter.inv.ExternalIO_1_ActivationTime" :key="index + '1D'">
              <v-text-field @focus="stopTimerParameters" v-model="item.parameterValue" @change="sendValue(item)" type="number" :label="getLabel(item)" :disabled="isExternalIO1Enabled" :hint="$t('externalio.example') + '10 s'" persistent-hint suffix="s"></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6" v-for="(item, index) in parameter.inv.ExternalIO_1_DeactivationTime" :key="index + '1E'">
              <v-text-field @focus="stopTimerParameters" v-model="item.parameterValue" @change="sendValue(item)" type="number" :label="getLabel(item)" :disabled="isExternalIO1Enabled" :hint="$t('externalio.example') + '300 s'" persistent-hint suffix="s"></v-text-field>
            </v-col>
          </v-row>

          <v-row class="my-border-blue" dense>
            <v-col cols="12" md="3" sm="4" align="center" class="mt-6">
              <v-chip color="blue" outlined>
                <b>
                  {{ $t("externalio.output") }}
                  2
                  {{ isExternalIO2Enabled ? $t("externalio.autoMode") : $t("externalio.manualMode") }}
                </b>
              </v-chip>
            </v-col>

            <v-col cols="12" md="auto" sm="4" class="mx-2" v-for="(item, index) in parameter.inv.ExternalIO_2_Enabled" :key="index + '2A'">
              <v-switch dense v-model="item.parameterValue" @change="sendValueSwitch(item)" :label="getLabel(item)" color="primary" :hint="$t('externalio.example') + $t('externalio.on')" persistent-hint> </v-switch>
            </v-col>

            <v-col cols="12" md="auto" sm="4" class="mx-2" v-for="(item, index) in parameter.inv.ExternalIO_2_SOCInsteadOfPowerEnabled" :key="index + '2F'">
              <v-switch dense v-model="item.parameterValue" @change="sendValueSwitch(item)" :label="getLabel(item)" color="primary" :disabled="isExternalIO2Enabled" :hint="$t('externalio.controlBasedOnPowerOrSOC')" persistent-hint> </v-switch>
            </v-col>
          </v-row>

          <v-row class="my-border-blue" dense>
            <v-col cols="12" md="2" sm="6" offset-md="3" v-for="(item, index) in parameter.inv.ExternalIO_2_PLockIn" :key="index + '2B'">
              <v-text-field
                @focus="stopTimerParameters"
                v-model="item.parameterValue"
                @change="sendValue(item)"
                type="number"
                :label="getLabel(item)"
                :disabled="isExternalIO2Enabled"
                :hint="$t('externalio.example') + (isExternalIO2SOCInsteadOfPowerEnabled ? '80 %' : '-500 W')"
                persistent-hint
                :suffix="isExternalIO2SOCInsteadOfPowerEnabled ? '%' : 'W'"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6" v-for="(item, index) in parameter.inv.ExternalIO_2_PLockOut" :key="index + '2C'">
              <v-text-field
                @focus="stopTimerParameters"
                v-model="item.parameterValue"
                @change="sendValue(item)"
                type="number"
                :label="getLabel(item)"
                :disabled="isExternalIO2Enabled"
                :hint="$t('externalio.example') + (isExternalIO2SOCInsteadOfPowerEnabled ? '70 %' : '200 W')"
                persistent-hint
                :suffix="isExternalIO2SOCInsteadOfPowerEnabled ? '%' : 'W'"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6" v-for="(item, index) in parameter.inv.ExternalIO_2_ActivationTime" :key="index + '2D'">
              <v-text-field @focus="stopTimerParameters" v-model="item.parameterValue" @change="sendValue(item)" type="number" :label="getLabel(item)" :disabled="isExternalIO2Enabled" :hint="$t('externalio.example') + '600 s'" persistent-hint suffix="s"></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6" v-for="(item, index) in parameter.inv.ExternalIO_2_DeactivationTime" :key="index + '2E'">
              <v-text-field @focus="stopTimerParameters" v-model="item.parameterValue" @change="sendValue(item)" type="number" :label="getLabel(item)" :disabled="isExternalIO2Enabled" :hint="$t('externalio.example') + '300 s'" persistent-hint suffix="s"></v-text-field>
            </v-col>
          </v-row>

          <v-row class="my-border-green" dense>
            <v-col cols="12" md="3" sm="4" align="center" class="mt-6">
              <v-chip color="green" outlined>
                <b>
                  {{ $t("externalio.output") }}
                  3
                  {{ isExternalIO3Enabled ? $t("externalio.autoMode") : $t("externalio.manualMode") }}
                </b>
              </v-chip>
            </v-col>

            <v-col cols="12" md="auto" sm="4" class="mx-2" v-for="(item, index) in parameter.inv.ExternalIO_3_Enabled" :key="index + '3A'">
              <v-switch dense v-model="item.parameterValue" @change="sendValueSwitch(item)" :label="getLabel(item)" color="primary" :hint="$t('externalio.example') + $t('externalio.off')" persistent-hint> </v-switch>
            </v-col>

            <v-col cols="12" md="auto" sm="4" class="mx-2" v-for="(item, index) in parameter.inv.ExternalIO_3_SOCInsteadOfPowerEnabled" :key="index + '3F'">
              <v-switch dense v-model="item.parameterValue" @change="sendValueSwitch(item)" :label="getLabel(item)" color="primary" :disabled="isExternalIO3Enabled" :hint="$t('externalio.controlBasedOnPowerOrSOC')" persistent-hint> </v-switch>
            </v-col>
          </v-row>

          <v-row class="my-border-green" dense>
            <v-col cols="12" md="2" sm="6" offset-md="3" v-for="(item, index) in parameter.inv.ExternalIO_3_PLockIn" :key="index + '3B'">
              <v-text-field
                @focus="stopTimerParameters"
                v-model="item.parameterValue"
                @change="sendValue(item)"
                type="number"
                :label="getLabel(item)"
                :disabled="isExternalIO3Enabled"
                :hint="$t('externalio.example') + (isExternalIO3SOCInsteadOfPowerEnabled ? '0 %' : '0 W')"
                persistent-hint
                :suffix="isExternalIO3SOCInsteadOfPowerEnabled ? '%' : 'W'"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6" v-for="(item, index) in parameter.inv.ExternalIO_3_PLockOut" :key="index + '3C'">
              <v-text-field
                @focus="stopTimerParameters"
                v-model="item.parameterValue"
                @change="sendValue(item)"
                type="number"
                :label="getLabel(item)"
                :disabled="isExternalIO3Enabled"
                :hint="$t('externalio.example') + (isExternalIO3SOCInsteadOfPowerEnabled ? '0 %' : '0 W')"
                persistent-hint
                :suffix="isExternalIO3SOCInsteadOfPowerEnabled ? '%' : 'W'"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6" v-for="(item, index) in parameter.inv.ExternalIO_3_ActivationTime" :key="index + '3D'">
              <v-text-field @focus="stopTimerParameters" v-model="item.parameterValue" @change="sendValue(item)" type="number" :label="getLabel(item)" :disabled="isExternalIO3Enabled" :hint="$t('externalio.example') + '0 s'" persistent-hint suffix="s"></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6" v-for="(item, index) in parameter.inv.ExternalIO_3_DeactivationTime" :key="index + '3E'">
              <v-text-field @focus="stopTimerParameters" v-model="item.parameterValue" @change="sendValue(item)" type="number" :label="getLabel(item)" :disabled="isExternalIO3Enabled" :hint="$t('externalio.example') + '0 s'" persistent-hint suffix="s"></v-text-field>
            </v-col>
          </v-row>

          <v-row class="my-border-orange" dense>
            <v-col cols="12" md="3" sm="4" align="center" class="mt-6">
              <v-chip color="orange" outlined>
                <b>
                  {{ $t("externalio.output") }}
                  4
                  {{ isExternalIO4Enabled ? $t("externalio.autoMode") : $t("externalio.manualMode") }}
                </b>
              </v-chip>
            </v-col>

            <v-col cols="12" md="auto" sm="4" class="mx-2" v-for="(item, index) in parameter.inv.ExternalIO_4_Enabled" :key="index + '4A'">
              <v-switch dense class="mb-4" v-model="item.parameterValue" @change="sendValueSwitch(item)" :label="getLabel(item)" color="primary" :hint="$t('externalio.example') + $t('externalio.off')" persistent-hint> </v-switch>
            </v-col>

            <v-col cols="12" md="auto" sm="4" class="mx-2" v-for="(item, index) in parameter.inv.ExternalIO_4_SOCInsteadOfPowerEnabled" :key="index + '4F'">
              <v-switch dense v-model="item.parameterValue" @change="sendValueSwitch(item)" :label="getLabel(item)" color="primary" :disabled="isExternalIO4Enabled" :hint="$t('externalio.controlBasedOnPowerOrSOC')" persistent-hint> </v-switch>
            </v-col>
          </v-row>

          <v-row class="my-border-orange" dense>
            <v-col cols="12" md="2" sm="6" offset-md="3" v-for="(item, index) in parameter.inv.ExternalIO_4_PLockIn" :key="index + '4B'">
              <v-text-field
                @focus="stopTimerParameters"
                v-model="item.parameterValue"
                @change="sendValue(item)"
                type="number"
                :label="getLabel(item)"
                :disabled="isExternalIO4Enabled"
                :hint="$t('externalio.example') + (isExternalIO4SOCInsteadOfPowerEnabled ? '0 %' : '0 W')"
                persistent-hint
                :suffix="isExternalIO4SOCInsteadOfPowerEnabled ? '%' : 'W'"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6" v-for="(item, index) in parameter.inv.ExternalIO_4_PLockOut" :key="index + '4C'">
              <v-text-field
                @focus="stopTimerParameters"
                v-model="item.parameterValue"
                @change="sendValue(item)"
                type="number"
                :label="getLabel(item)"
                :disabled="isExternalIO4Enabled"
                :hint="$t('externalio.example') + (isExternalIO4SOCInsteadOfPowerEnabled ? '0 %' : '0 W')"
                persistent-hint
                :suffix="isExternalIO4SOCInsteadOfPowerEnabled ? '%' : 'W'"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6" v-for="(item, index) in parameter.inv.ExternalIO_4_ActivationTime" :key="index + '4D'">
              <v-text-field @focus="stopTimerParameters" v-model="item.parameterValue" @change="sendValue(item)" type="number" :label="getLabel(item)" :disabled="isExternalIO4Enabled" :hint="$t('externalio.example') + '0 s'" persistent-hint suffix="s"></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6" v-for="(item, index) in parameter.inv.ExternalIO_4_DeactivationTime" :key="index + '4E'">
              <v-text-field @focus="stopTimerParameters" v-model="item.parameterValue" @change="sendValue(item)" type="number" :label="getLabel(item)" :disabled="isExternalIO4Enabled" :hint="$t('externalio.example') + '0 s'" persistent-hint suffix="s"></v-text-field>
            </v-col>
          </v-row>
        </template>

        <template v-else>
          <LoadingData />
        </template>
      </v-tab-item>

      <!-- Parametry-->
      <v-tab-item class="ma-2">
        <template v-if="this.parameters != null && this.main != null">
          <v-tabs show-arrows="always" color="primary" right background-color="transparent">
            <v-tabs-slider color="primary"></v-tabs-slider>

            <v-tab> <v-icon left> mdi-transmission-tower-import </v-icon>{{ $t("userInterface.userParameters.headers.chargingFromGrid") }}</v-tab>
            <v-tab> <v-icon left> mdi-battery-medium </v-icon>{{ $t("userInterface.userParameters.headers.batteryDischarge") }}</v-tab>
            <v-tab> <v-icon left> mdi-transmission-tower-export</v-icon>{{ $t("userInterface.userParameters.headers.overflowsControl") }}</v-tab>
            <v-tab> <v-icon left> mdi-weather-cloudy</v-icon>{{ $t("userInterface.userParameters.headers.ecai") }}</v-tab>

            <!-- Nabíjení ze sítě -->
            <v-tab-item class="ma-2">
              <v-row dense>
                <v-col cols="12">
                  <h2>{{ $t("userInterface.userParameters.chargingFromGrid.header1") }}</h2>

                  <template v-if="checkUnitsVersions_Charging() === true">
                    <v-icon class="mx-2 mb-2" color="green">mdi-check-circle-outline</v-icon> <i class="caption" style="color: green; font-weight: bold"> {{ $t("userInterface.userParameters.chargingFromGrid.supported") }}</i> <br />
                  </template>

                  {{ $t("userInterface.userParameters.chargingFromGrid.text1") }}
                </v-col>

                <template v-if="checkUnitsVersions_Charging() === true">
                  <template v-if="parameter.inv.User_SOCLevelForStopCharging.length > 0">
                    <v-col cols="12">
                      {{ $t("userInterface.userParameters.chargingFromGrid.currentSOC") }} <v-icon class="mx-2" color="primary">mdi-battery-charging-medium</v-icon> <b> {{ totalSOC }} % </b>
                    </v-col>

                    <v-col cols="12" md="7">
                      <h3>{{ $t("userInterface.userParameters.chargingFromGrid.headerSlider") }}</h3>
                      <v-slider
                        dense
                        v-model="parameter.inv.User_SOCLevelForStopCharging[0].parameterValue"
                        @click="stopTimerParameters"
                        @change="sendValue(parameter.inv.User_SOCLevelForStopCharging[0])"
                        class="mt-14 ma-4"
                        thumb-color="primary"
                        :thumb-size="sliderThumbSize"
                        :min="0"
                        :max="95"
                        :step="1"
                        thumb-label="always"
                      >
                        <template v-slot:thumb-label="{ value }">
                          {{ value + " %" }}
                        </template>
                      </v-slider>
                    </v-col>
                    <v-col cols="12" md="5">
                      <ButtonHover :class="$vuetify.breakpoint.mdAndUp ? 'mt-14' : 'mt-0'" :command="'invertercharge'" :icons="['mdi-battery-charging-medium']" :plain="true" :small="false" :span="$t('userInterface.userParameters.chargingFromGrid.buttonText')"></ButtonHover>
                    </v-col>
                    <v-col cols="12">
                      <i class="caption">
                        {{ $t("userInterface.userParameters.chargingFromGrid.info1") }}
                      </i>
                      <br />
                      <br />

                      <i class="caption">
                        {{ $t("userInterface.userParameters.chargingFromGrid.info2") }}
                      </i>
                    </v-col>
                  </template>
                </template>

                <template v-else>
                  <v-col cols="12">
                    <AlertVersion
                      :notSupportedHeader="$t('userInterface.userParameters.chargingFromGrid.notSupported')"
                      :ccuRequiredVersion="features.requiredVersions.charging.ccu"
                      :ccuCurrentVersion="main.version"
                      :inverterRequiredVersion="features.requiredVersions.charging.inv"
                      :inverterCurrentVersion="main.inverter.version"
                    />
                  </v-col>
                </template>

                <v-col cols="12">
                  <h2>{{ $t("userInterface.userParameters.safetyChargingFromGrid.header1") }}</h2>
                  {{ $t("userInterface.userParameters.safetyChargingFromGrid.text1") }} <br />
                  {{ $t("userInterface.userParameters.safetyChargingFromGrid.text2") }} [ X1 = <b> {{ sliderValues[0] }} % </b> ] {{ $t("userInterface.userParameters.safetyChargingFromGrid.text3") }} [ X2 = <b> {{ sliderValues[1] }} % </b> ]. <br />
                </v-col>

                <v-col cols="12">
                  <h3>{{ $t("userInterface.userParameters.safetyChargingFromGrid.headerSlider") }}</h3>
                  <i class="caption" style="color: #757575; font-weight: bold"> ({{ $t("userInterface.userParameters.safetyChargingFromGrid.info1") }})</i>
                </v-col>
                <v-col cols="12" md="8">
                  <v-range-slider dense class="mt-14 ma-4" v-model="sliderValues" thumb-color="#757575" :thumb-size="sliderThumbSize" min="0" max="10" thumb-label="always" readonly>
                    <template v-slot:thumb-label="{ value }">
                      {{ value + " %" }}
                    </template>
                  </v-range-slider>
                </v-col>
              </v-row>
            </v-tab-item>

            <!-- Vybíjení baterií -->
            <v-tab-item class="ma-2">
              <v-row dense>
                <v-col cols="12">
                  <h2>
                    {{ $t("userInterface.userParameters.batteryDischarge.header1") }}
                  </h2>

                  <template v-if="checkUnitsVersions_Parameters() === true">
                    <v-icon class="mx-2 mb-2" color="green">mdi-check-circle-outline</v-icon> <i class="caption" style="color: green; font-weight: bold"> {{ $t("userInterface.userParameters.parameters.supported") }}</i> <br />
                  </template>

                  <p>{{ $t("userInterface.userParameters.batteryDischarge.text1") }}</p>
                </v-col>

                <template v-if="checkUnitsVersions_Parameters() === true">
                  <template v-if="parameter.inv.SOCLevelForMinPower.length > 0">
                    <v-col cols="12">
                      <i class="caption">
                        {{ $t("userInterface.userParameters.batteryDischarge.info1") }} <br />
                        {{ $t("userInterface.userParameters.batteryDischarge.info2") }}
                      </i>
                    </v-col>

                    <v-col cols="12">
                      <h3>{{ $t("userInterface.userParameters.batteryDischarge.headerSlider") }}</h3>

                      <v-slider
                        dense
                        v-model="parameter.inv.SOCLevelForMinPower[0].parameterValue"
                        @click="stopTimerParameters"
                        @change="sendValue(parameter.inv.SOCLevelForMinPower[0])"
                        class="mt-14 ma-4"
                        thumb-color="primary"
                        :thumb-size="sliderThumbSize"
                        :min="5"
                        :max="80"
                        :step="1"
                        thumb-label="always"
                      >
                        <template v-slot:thumb-label="{ value }">
                          {{ value + " %" }}
                        </template>
                      </v-slider>
                      <i class="caption">{{ $t("userInterface.userParameters.batteryDischarge.info3") }} </i>
                      <br />
                      <i class="caption">{{ $t("userInterface.userParameters.batteryDischarge.info4") }}</i>
                      <br />
                      <br />
                      <i class="caption">{{ $t("userInterface.userParameters.batteryDischarge.info5") }} </i>
                    </v-col>
                  </template>
                </template>

                <template v-else>
                  <v-col cols="12">
                    <AlertVersion
                      :notSupportedHeader="$t('userInterface.userParameters.parameters.notSupported')"
                      :ccuRequiredVersion="features.requiredVersions.parameters.ccu"
                      :ccuCurrentVersion="main.version"
                      :inverterRequiredVersion="features.requiredVersions.parameters.inv"
                      :inverterCurrentVersion="main.inverter.version"
                    />
                  </v-col>
                </template>

                <v-col cols="12">
                  <h2>
                    {{ $t("userInterface.userParameters.batteryDischarge.header2") }}
                  </h2>

                  <template v-if="checkUnitsVersions_Parameters() === true">
                    <v-icon class="mx-2 mb-2" color="green">mdi-check-circle-outline</v-icon> <i class="caption" style="color: green; font-weight: bold"> {{ $t("userInterface.userParameters.parameters.supported") }}</i> <br />
                  </template>

                  <p>{{ $t("userInterface.userParameters.batteryDischarge.info6") }}</p>
                </v-col>

                <template v-if="checkUnitsVersions_Parameters() === true">
                  <template v-if="parameter.inv.SOCLevelForDisableInverterInOffGrid.length > 0">
                    <v-col cols="12">
                      <i class="caption"> {{ $t("userInterface.userParameters.batteryDischarge.info7") }} </i> <br />
                    </v-col>

                    <v-col cols="12">
                      <h3>
                        {{ $t("userInterface.userParameters.batteryDischarge.headerSlider2") }} <i class="caption"> {{ $t("userInterface.userParameters.batteryDischarge.info8") }} </i>
                      </h3>

                      <v-slider
                        dense
                        v-model="parameter.inv.SOCLevelForDisableInverterInOffGrid[0].parameterValue"
                        @click="stopTimerParameters"
                        @change="sendValue(parameter.inv.SOCLevelForDisableInverterInOffGrid[0])"
                        class="mt-14 ma-4"
                        thumb-color="primary"
                        :thumb-size="sliderThumbSize"
                        :min="5"
                        :max="30"
                        :step="1"
                        thumb-label="always"
                      >
                        <template v-slot:thumb-label="{ value }">
                          {{ value + " %" }}
                        </template>
                      </v-slider>

                      <i class="caption"> {{ $t("userInterface.userParameters.batteryDischarge.info9") }} </i> <br />
                    </v-col>
                  </template>
                </template>

                <template v-else>
                  <v-col cols="12">
                    <AlertVersion
                      :notSupportedHeader="$t('userInterface.userParameters.parameters.notSupported')"
                      :ccuRequiredVersion="features.requiredVersions.parameters.ccu"
                      :ccuCurrentVersion="main.version"
                      :inverterRequiredVersion="features.requiredVersions.parameters.inv"
                      :inverterCurrentVersion="main.inverter.version"
                    />
                  </v-col>
                </template>
              </v-row>
            </v-tab-item>

            <v-tab-item class="ma-2">
              <v-row dense>
                <v-col cols="12">
                  <h2>{{ $t("userInterface.userParameters.overflows.header2") }}</h2>

                  <template v-if="checkUnitsVersions_Parameters() === true">
                    <v-icon class="mx-2 mb-2" color="green">mdi-check-circle-outline</v-icon> <i class="caption" style="color: green; font-weight: bold"> {{ $t("userInterface.userParameters.parameters.supported") }}</i> <br />
                  </template>

                  <p>{{ $t("userInterface.userParameters.overflows.info1") }}</p>
                </v-col>

                <template v-if="checkUnitsVersions_Parameters() === true">
                  <template v-if="parameter.inv.SOCLevelForENOverflows.length > 0">
                    <v-col cols="12">
                      <i class="caption"> {{ $t("userInterface.userParameters.overflows.info2") }} </i> <br />
                    </v-col>

                    <v-col cols="12">
                      <h3>{{ $t("userInterface.userParameters.overflows.sliderHeader") }}</h3>

                      <v-slider
                        dense
                        v-model="parameter.inv.SOCLevelForENOverflows[0].parameterValue"
                        @click="stopTimerParameters"
                        @change="sendValue(parameter.inv.SOCLevelForENOverflows[0])"
                        class="mt-14 ma-4"
                        thumb-color="primary"
                        :thumb-size="sliderThumbSize"
                        :min="50"
                        :max="100"
                        :step="1"
                        thumb-label="always"
                      >
                        <template v-slot:thumb-label="{ value }">
                          {{ value + " %" }}
                        </template>
                      </v-slider>

                      <i class="caption"> {{ $t("userInterface.userParameters.overflows.info3") }} </i> <br />
                      <i class="caption"> {{ $t("userInterface.userParameters.overflows.info4") }} </i> <br />
                    </v-col>
                  </template>
                </template>

                <template v-else>
                  <v-col cols="12">
                    <AlertVersion
                      :notSupportedHeader="$t('userInterface.userParameters.parameters.notSupported')"
                      :ccuRequiredVersion="features.requiredVersions.parameters.ccu"
                      :ccuCurrentVersion="main.version"
                      :inverterRequiredVersion="features.requiredVersions.parameters.inv"
                      :inverterCurrentVersion="main.inverter.version"
                    />
                  </v-col>
                </template>

                <v-col cols="12">
                  <h2>{{ $t("userInterface.userParameters.headers.overflows") }}</h2>

                  <template v-if="chcekUnitsVersions_Overflows() === true">
                    <v-icon class="mx-2 mb-2" color="green">mdi-check-circle-outline</v-icon> <i class="caption" style="color: green; font-weight: bold"> {{ $t("userInterface.userParameters.overflows.supported") }}</i> <br />
                  </template>
                  {{ $t("userInterface.userParameters.overflows.stockDesc") }}
                </v-col>

                <template v-if="chcekUnitsVersions_Overflows() === true">
                  <template v-if="parameter.inv.Overflows_MaximumReservedPower.length > 0 && parameter.inv.User_Overflows_MaximumReservedPower.length > 0 && parameter.inv.GeneralConfigBits.OverflowsEnabled.length > 0 && parameter.inv.UserConfigBits.OverflowsEnabled.length > 0">
                    <v-col cols="12">
                      <h3>{{ $t("userInterface.userParameters.overflows.maximumLevel") }}</h3>
                    </v-col>

                    <v-col cols="12" md="6">
                      <i class="caption">{{ $t("userInterface.userParameters.overflows.maximumLevelDesc") }}</i>

                      <b :style="'color: gray;'">
                        {{ parameter.inv.Overflows_MaximumReservedPower[0].parameterValue }}
                        {{ parameter.inv.Overflows_MaximumReservedPower[0].parameterUnits }}
                      </b>
                    </v-col>

                    <v-col cols="12" md="6">
                      <i class="caption">{{ $t("userInterface.userParameters.overflows.maximumLevelDescUsr") }} </i>
                      <b>
                        {{ parameter.inv.User_Overflows_MaximumReservedPower[0].parameterValue }}
                        {{ parameter.inv.User_Overflows_MaximumReservedPower[0].parameterUnits }}
                      </b>
                    </v-col>

                    <v-col cols="12">
                      <v-slider
                        dense
                        v-model="parameter.inv.User_Overflows_MaximumReservedPower[0].parameterValue"
                        @click="stopTimerParameters"
                        @change="sendValue(parameter.inv.User_Overflows_MaximumReservedPower[0])"
                        class="mt-14 ma-4"
                        thumb-color="primary"
                        :thumb-size="sliderThumbSize"
                        :min="parameter.inv.User_Overflows_MaximumReservedPower[0].min"
                        :max="parameter.inv.Overflows_MaximumReservedPower[0].parameterValue"
                        :step="100"
                        thumb-label="always"
                      >
                        <template v-slot:thumb-label="{ value }">
                          {{ Math.round((value * 100) / 100) / 1000 + " kW" }}
                        </template>
                      </v-slider>
                    </v-col>

                    <v-col cols="12">
                      <h3>{{ $t("userInterface.userParameters.overflows.enabled") }}</h3>
                    </v-col>

                    <v-col cols="12" md="6">
                      <i class="caption">{{ $t("userInterface.userParameters.overflows.overflowsAllowedDesc") }}</i>

                      <v-switch dense v-model="parameter.inv.GeneralConfigBits.OverflowsEnabled[0].bitValue" :disabled="true" @change="sendBitValue(parameter.inv.GeneralConfigBits.OverflowsEnabled[0])" :label="getLabel(parameter.inv.GeneralConfigBits.OverflowsEnabled[0])" color="primary">
                      </v-switch>
                    </v-col>

                    <v-col cols="12" md="6">
                      <i class="caption">{{ $t("userInterface.userParameters.overflows.overflowsUserAllowedDesc") }} </i>
                      <v-switch dense v-model="parameter.inv.UserConfigBits.OverflowsEnabled[0].bitValue" @change="sendBitValue(parameter.inv.UserConfigBits.OverflowsEnabled[0])" :label="getLabel(parameter.inv.UserConfigBits.OverflowsEnabled[0])" color="primary"> </v-switch>
                    </v-col>
                  </template>
                </template>

                <template v-else>
                  <v-col cols="12">
                    <i>
                      <v-alert type="warning"
                        >{{ $t("userInterface.userParameters.overflows.notSupported") }}
                        <v-row dense>
                          <v-col cols="auto">
                            {{ $t("userInterface.version.ccu") }}
                            <br />
                            {{ $t("userInterface.version.inverter") }}
                          </v-col>
                          <v-col cols="auto">
                            {{ $t("userInterface.version.requiredVersion") }} <b>{{ features.requiredVersions.overflows.ccu }}+</b>
                            <br />
                            {{ $t("userInterface.version.requiredVersion") }} <b>{{ features.requiredVersions.overflows.inv }}+</b>
                          </v-col>
                          <v-col cols="auto">
                            {{ $t("userInterface.version.currentVersion") }} <b>{{ main.version }}</b>
                            <br />
                            {{ $t("userInterface.version.currentVersion") }} <b>{{ main.inverter.version }}</b>
                          </v-col>
                        </v-row>
                      </v-alert>
                    </i>
                  </v-col>
                </template>
              </v-row>
            </v-tab-item>

            <!-- ECAI -->
            <v-tab-item class="ma-2">
              <v-row dense>
                <v-col cols="12">
                  <h2>{{ $t("userInterface.userParameters.ecai.header1") }}</h2>

                  <template v-if="checkUnitsVersion_ECAI() === true">
                    <v-icon class="mx-2 mb-2" color="green">mdi-check-circle-outline</v-icon> <i class="caption" style="color: green; font-weight: bold"> {{ $t("userInterface.userParameters.ecai.supported") }}</i> <br />
                  </template>
                </v-col>

                <template v-if="checkUnitsVersion_ECAI() === true">
                  {{ $t("userInterface.userParameters.ecai.text1") }}

                  <template v-if="parameter.inv.UserConfigBits.HigherEnergyManagementEnabled.length > 0">
                    <v-col cols="12" md="6">
                      <v-switch
                        dense
                        v-model="parameter.inv.UserConfigBits.HigherEnergyManagementEnabled[0].bitValue"
                        @change="sendBitValue(parameter.inv.UserConfigBits.HigherEnergyManagementEnabled[0])"
                        :label="getLabel(parameter.inv.UserConfigBits.HigherEnergyManagementEnabled[0])"
                        color="primary"
                      >
                      </v-switch>
                    </v-col>
                  </template>
                </template>

                <template v-else>
                  <v-col cols="12">
                    <AlertVersion
                      :notSupportedHeader="$t('userInterface.userParameters.ecai.notSupported')"
                      :ccuRequiredVersion="features.requiredVersions.ecai.ccu"
                      :ccuCurrentVersion="main.version"
                      :inverterRequiredVersion="features.requiredVersions.ecai.inv"
                      :inverterCurrentVersion="main.inverter.version"
                    />

                    <!--  TODO CCU neposílá verzi celkové bateriové jednotky
                    :batteryRequiredVersion="features.requiredVersions.ecai.battery"
                  :batteryCurrentVersion="main.battery.version" -->
                  </v-col>
                </template>
              </v-row>
            </v-tab-item>
          </v-tabs>
        </template>

        <template v-else>
          <LoadingData />
        </template>
      </v-tab-item>

      <!-- Control-->
      <v-tab-item class="ma-2">
        <template v-if="this.main != null">
          <v-row dense>
            <v-col cols="12">
              <h2>{{ $t("userInterface.control.headers.powerplant") }}</h2>
            </v-col>

            <v-col cols="12">
              <v-row dense>
                <v-col cols="12">
                  <h3>{{ $t("userInterface.control.headers.fve") }}</h3>
                </v-col>

                <v-col cols="12" md="8">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on"
                        >{{ $t("home.solar.state") }}: <b>{{ main.pv.state != "" ? $t("variableValues.state." + main.pv.state.replace("ERR_", "")) : "" }}</b>
                      </span>
                    </template>
                    <span>{{ main.pv.state }}</span>
                  </v-tooltip>
                </v-col>

                <v-col cols="12" md="8"> {{ $t("userInterface.control.fve") }} </v-col>

                <v-col cols="12" md="4">
                  <template v-if="$vuetify.breakpoint.smAndDown">
                    <br />
                  </template>

                  <v-row justify="end">
                    <ButtonHover class="mx-2" :command="'mppton'" :icons="['mdi-power-on']" :plain="true" :small="false" :span="$t('control.inverter.on')"></ButtonHover>
                    <ButtonHover class="mx-2" :command="'mpptoff'" :icons="['mdi-power-off']" :plain="true" :small="false" :span="$t('control.inverter.off')"></ButtonHover>
                  </v-row>
                </v-col>

                <v-col cols="12" class="my-4">
                  <v-alert type="info"> {{ $t("userInterface.control.fveInfo") }} </v-alert>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12">
              <v-row dense>
                <v-col cols="12">
                  <h3>{{ $t("userInterface.control.headers.battery") }}</h3>
                </v-col>

                <v-col cols="12" md="8">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on"
                        >{{ $t("home.solar.state") }}: <b>{{ main.battery.state != "" ? $t("variableValues.state." + main.battery.state.replace("ERR_", "")) : "" }}</b>
                      </span>
                    </template>
                    <span>{{ main.battery.state }}</span>
                  </v-tooltip>
                </v-col>

                <v-col cols="12" md="8"> {{ $t("userInterface.control.battery") }} </v-col>

                <v-col cols="12" md="4">
                  <template v-if="$vuetify.breakpoint.smAndDown">
                    <br />
                  </template>

                  <v-row justify="end">
                    <ButtonHover class="mx-2" :command="'dabon'" :icons="['mdi-power-on']" :plain="true" :small="false" :span="$t('control.inverter.on')"></ButtonHover>
                    <ButtonHover class="mx-2" :command="'daboff'" :icons="['mdi-power-off']" :plain="true" :small="false" :span="$t('control.inverter.off')"></ButtonHover>

                    <!--                     <v-btn class="mx-2" small @click="sendCommand('dabon')" color="primary">
                      <span>{{ $t("control.inverter.on") }} </span>
                      <v-icon>mdi-power-on</v-icon>
                    </v-btn>

                    <v-btn class="mx-2" small @click="sendCommand('daboff')" color="primary">
                      <span>{{ $t("control.inverter.off") }} </span>
                      <v-icon>mdi-power-off</v-icon>
                    </v-btn> -->
                  </v-row>
                </v-col>

                <v-col cols="12" class="my-4">
                  <v-alert type="warning"> {{ $t("userInterface.control.batteryWarning") }}</v-alert>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12">
              <v-row dense>
                <v-col cols="12">
                  <h3>{{ $t("userInterface.control.headers.recovery") }}</h3>
                </v-col>

                <v-col cols="12" md="8">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <div style="color: red">
                          <template v-if="main.inverter.error1 != ''">
                            {{ $t("home.output.error") }}: <b>{{ main.inverter.error1 != "" ? $t("variableValues.error." + main.inverter.error1) : "" }}</b>
                          </template>
                        </div>
                      </span>
                    </template>
                    <span>{{ main.inverter.error1 }}</span>
                  </v-tooltip>
                </v-col>

                <v-col cols="12" md="8"> {{ $t("userInterface.control.recovery") }} </v-col>

                <v-col cols="12" md="4">
                  <template v-if="$vuetify.breakpoint.smAndDown">
                    <br />
                  </template>

                  <v-row dense justify="end">
                    <ButtonHover class="mx-2" :command="'clearerror'" :icons="['mdi-medical-bag']" :plain="true" :small="false" :span="$t('control.others.clearError')"></ButtonHover>
                  </v-row>
                </v-col>

                <v-col cols="12" class="my-4">
                  <v-alert type="error"> {{ $t("userInterface.control.recoveryError") }} </v-alert>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>

        <template v-else>
          <LoadingData />
        </template>
      </v-tab-item>
    </v-tabs>

    <UpgradeCore />
  </div>
</template>

<script>
  import AlertVersion from "../../components/alert/AlertVersion.vue";
  import UpgradeCore from "../../components/upgrade/UpgradeCore.vue";
  import LoadingData from "../../components/LoadingData.vue";
  import ButtonHover from "../../components/button/ButtonHover.vue";

  import { ServiceClient } from "../../service_client/index.js";

  import { mapState } from "vuex";

  export default {
    name: "UserInterface",
    props: {},
    components: {
      AlertVersion,
      LoadingData,
      UpgradeCore,
      ButtonHover,
    },
    data() {
      return {
        sliderThumbSize: "42",

        showIOSettings: 0,

        itemsSetNameInput: [{ name: "" }, { name: "" }, { name: "" }, { name: "" }],
        itemsSetNameOutput: [{ name: "" }, { name: "" }, { name: "" }, { name: "" }],

        timerMain: null,
        timerExternal: null,
        timerParameters: null,

        refreshParameters: true,

        features: {
          requiredVersions: {
            charging: {
              ccu: "44.9",
              inv: "44.5",
            },
            parameters: {
              ccu: "44.3",
              inv: "44.1",
            },
            overflows: {
              ccu: "42.22",
              inv: "42.18",
            },
            ecai: {
              ccu: "51.9",
              inv: "51.7",
              dab: "51.2", // TODO kontrola
            },
          },
        },

        totalSOC: 0,

        main: null,
        external: null,
        parameters: null,

        sliderValues: [],

        parameter: {
          inv: {
            ExternalIO_1_SOCInsteadOfPowerEnabled: [],
            ExternalIO_1_Enabled: [],
            ExternalIO_1_PLockIn: [],
            ExternalIO_1_PLockOut: [],
            ExternalIO_1_ActivationTime: [],
            ExternalIO_1_DeactivationTime: [],

            ExternalIO_2_SOCInsteadOfPowerEnabled: [],
            ExternalIO_2_Enabled: [],
            ExternalIO_2_PLockIn: [],
            ExternalIO_2_PLockOut: [],
            ExternalIO_2_ActivationTime: [],
            ExternalIO_2_DeactivationTime: [],

            ExternalIO_3_SOCInsteadOfPowerEnabled: [],
            ExternalIO_3_Enabled: [],
            ExternalIO_3_PLockIn: [],
            ExternalIO_3_PLockOut: [],
            ExternalIO_3_ActivationTime: [],
            ExternalIO_3_DeactivationTime: [],

            ExternalIO_4_SOCInsteadOfPowerEnabled: [],
            ExternalIO_4_Enabled: [],
            ExternalIO_4_PLockIn: [],
            ExternalIO_4_PLockOut: [],
            ExternalIO_4_ActivationTime: [],
            ExternalIO_4_DeactivationTime: [],

            Overflows_MaximumReservedPower: [],

            User_Overflows_MaximumReservedPower: [],

            User_SOCLevelForStopCharging: [],

            SOCLevelForENOverflows: [],
            SOCLevelForMinPower: [],
            SOCLevelForStartCharging: [],
            SOCLevelForStopCharging: [],
            SOCLevelForDisableInverterInOffGrid: [],

            GeneralConfigBits: {
              OverflowsEnabled: [],
            },

            UserConfigBits: {
              OverflowsEnabled: [],
              HigherEnergyManagementEnabled: [],
            },
          },
        },
      };
    },
    created() {
      this.getMain();
      this.getExternal();
      this.getParameters();

      this.loadNames();
    },
    mounted() {
      this.pollMain();
      this.pollExternal();
      this.pollParameters();
    },

    computed: {
      ...mapState({
        account: (state) => state.account,
      }),
      isExternalIO1SOCInsteadOfPowerEnabled() {
        return this.isExternalIOSOCInsteadOfPowerEnabled(1);
      },
      isExternalIO2SOCInsteadOfPowerEnabled() {
        return this.isExternalIOSOCInsteadOfPowerEnabled(2);
      },
      isExternalIO3SOCInsteadOfPowerEnabled() {
        return this.isExternalIOSOCInsteadOfPowerEnabled(3);
      },
      isExternalIO4SOCInsteadOfPowerEnabled() {
        return this.isExternalIOSOCInsteadOfPowerEnabled(4);
      },
      isExternalIO1Enabled() {
        return this.isExternalIOEnabled(1);
      },
      isExternalIO2Enabled() {
        return this.isExternalIOEnabled(2);
      },
      isExternalIO3Enabled() {
        return this.isExternalIOEnabled(3);
      },
      isExternalIO4Enabled() {
        return this.isExternalIOEnabled(4);
      },
    },
    methods: {
      chcekUnitsVersions_Overflows() {
        return this.checkUnitsVersions("overflows");
      },
      checkUnitsVersions_Charging() {
        return this.checkUnitsVersions("charging");
      },
      checkUnitsVersions_Parameters() {
        return this.checkUnitsVersions("parameters");
      },
      checkUnitsVersion_ECAI() {
        return this.checkUnitsVersions("ecai");
      },
      checkUnitsVersions(operation) {
        let requiredVersionCCU = "";
        let requiredVersionINV = "";

        const parseVersion = (version) => {
          const [major, minor] = version.split(".").map(Number);
          return { major, minor: minor || 0 };
        };

        let currentVersionCCU = parseVersion(this.main.version);
        let currentVersionINV = parseVersion(this.main.inverter.version);

        switch (operation) {
          case "charging":
            requiredVersionCCU = parseVersion(this.features.requiredVersions.charging.ccu);
            requiredVersionINV = parseVersion(this.features.requiredVersions.charging.inv);
            break;

          case "parameters":
            requiredVersionCCU = parseVersion(this.features.requiredVersions.parameters.ccu);
            requiredVersionINV = parseVersion(this.features.requiredVersions.parameters.inv);

            break;

          case "overflows":
            requiredVersionCCU = parseVersion(this.features.requiredVersions.overflows.ccu);
            requiredVersionINV = parseVersion(this.features.requiredVersions.overflows.inv);
            break;

          case "ecai":
            requiredVersionCCU = parseVersion(this.features.requiredVersions.ecai.ccu);
            requiredVersionINV = parseVersion(this.features.requiredVersions.ecai.inv);
            break;

          default:
            break;
        }

        const isVersionSufficient = (current, required) => current.major > required.major || (current.major === required.major && current.minor >= required.minor);

        if (!isVersionSufficient(currentVersionCCU, requiredVersionCCU)) {
          return false;
        }

        if (!isVersionSufficient(currentVersionINV, requiredVersionINV)) {
          return false;
        }

        /*         if (!isVersionSufficient(currentVersionBAT, requiredVersionBAT)) {
          return false;
        } */

        return true;
      },
      loadNames() {
        if (localStorage.getItem("userInput") !== null) {
          this.itemsSetNameInput = JSON.parse(localStorage.getItem("userInput"));
        }
        if (localStorage.getItem("userOutput") !== null) {
          this.itemsSetNameOutput = JSON.parse(localStorage.getItem("userOutput"));
        }
      },
      saveNames() {
        localStorage.setItem("userInput", JSON.stringify(this.itemsSetNameInput));
        localStorage.setItem("userOutput", JSON.stringify(this.itemsSetNameOutput));
      },
      changeIOName(IO, index, name) {
        if (IO === "IN") {
          this.itemsSetNameInput[index].name = name;
        } else if (IO === "OUT") {
          this.itemsSetNameOutput[index].name = name;
        }
      },
      collapseInputOutputDown() {
        if (this.showIOSettings === 0) {
          this.showIOSettings = 1;
        } else {
          this.showIOSettings = 0;
        }
      },
      isExternalIOEnabled(input) {
        switch (input) {
          case 1:
            return this.isExternalIOValidatedAndActive(this.parameter.inv.ExternalIO_1_Enabled);
          case 2:
            return this.isExternalIOValidatedAndActive(this.parameter.inv.ExternalIO_2_Enabled);
          case 3:
            return this.isExternalIOValidatedAndActive(this.parameter.inv.ExternalIO_3_Enabled);
          case 4:
            return this.isExternalIOValidatedAndActive(this.parameter.inv.ExternalIO_4_Enabled);
          default:
            return false;
        }
      },
      isExternalIOSOCInsteadOfPowerEnabled(input) {
        switch (input) {
          case 1:
            return this.isExternalIOValidatedAndActive(this.parameter.inv.ExternalIO_1_SOCInsteadOfPowerEnabled);
          case 2:
            return this.isExternalIOValidatedAndActive(this.parameter.inv.ExternalIO_2_SOCInsteadOfPowerEnabled);
          case 3:
            return this.isExternalIOValidatedAndActive(this.parameter.inv.ExternalIO_3_SOCInsteadOfPowerEnabled);
          case 4:
            return this.isExternalIOValidatedAndActive(this.parameter.inv.ExternalIO_4_SOCInsteadOfPowerEnabled);
          default:
            return false;
        }
      },
      isExternalIOValidatedAndActive(array) {
        if (array != null && array.length > 0 && "parameterValue" in array[0]) {
          return array[0].parameterValue === 1;
        }
        return false;
      },
      getColor(type, index) {
        if (type == "inputs") {
          if (this.external.external.inputs & (1 << index)) {
            return "red darken-1";
          } else {
            return "primary";
          }
        } else if (type == "outputs") {
          if (this.external.external.outputs & (1 << index)) {
            return "red darken-1";
          } else {
            return "primary";
          }
        }
      },
      isNotActive(type, index) {
        if (type == "inputs") {
          if (this.external.external.inputs & (1 << index)) {
            return false;
          } else {
            return true;
          }
        } else if (type == "outputs") {
          if (this.external.external.outputs & (1 << index)) {
            return false;
          } else {
            return true;
          }
        }
      },
      toggleOutput(index) {
        this.sendCommandTgl("outputtgl", index);
      },
      sendCommandTgl(command, par) {
        let parameters = "?cmd=" + command + "&par=" + par;

        ServiceClient.dataCore(ServiceClient.getAPIUrl("command"), null, parameters, "GET").catch((error) => {
          ServiceClient.handleUnauthorized(error, this.$router);
        });
      },
      sendCommand(value) {
        ServiceClient.dataCore(ServiceClient.getAPIUrl("command"), null, "?cmd=" + value, "GET").catch((error) => {
          ServiceClient.handleUnauthorized(error, this.$router);
        });
      },
      stopTimerParameters() {
        this.refreshParameters = false;
      },
      refreshTimer() {
        this.refreshParameters = true;
      },
      getMain() {
        ServiceClient.dataCore(ServiceClient.getAPIUrl("main"), null, null, "GET")
          .then((data) => {
            this.main = data;

            this.totalSOC = 0;

            let counter = 0;
            for (let index = 0; index < this.main.battery.batteries.length; index++) {
              if (this.main.battery.batteries[index].state != "Reset") {
                this.totalSOC += this.main.battery.batteries[index].bms.soc;
                counter++;
              }

              if (index == this.main.battery.batteries.length - 1) {
                this.totalSOC /= counter;
              }
            }
          })
          .catch((error) => {
            this.main = ServiceClient.handleUnauthorized(error, this.$router);
          });
      },
      pollMain() {
        this.timerMain = setInterval(() => {
          this.getMain();
        }, 3000);
      },
      getExternal() {
        ServiceClient.dataCore(ServiceClient.getAPIUrl("external"), null, null, "GET")
          .then((data) => {
            this.external = data;
          })
          .catch((error) => {
            this.external = ServiceClient.handleUnauthorized(error, this.$router);
          });
      },
      pollExternal() {
        this.timerExternal = setInterval(() => {
          this.getExternal();
        }, 1000);
      },
      getParameters() {
        ServiceClient.dataCore(ServiceClient.getAPIUrl("parameters"), null, null, "GET")
          .then((data) => {
            if (this.refreshParameters == false) {
              return;
            }

            this.parameters = data;

            this.parameter.inv.ExternalIO_1_Enabled = [];
            this.parameter.inv.ExternalIO_1_PLockIn = [];
            this.parameter.inv.ExternalIO_1_PLockOut = [];
            this.parameter.inv.ExternalIO_1_ActivationTime = [];
            this.parameter.inv.ExternalIO_1_DeactivationTime = [];
            this.parameter.inv.ExternalIO_1_SOCInsteadOfPowerEnabled = [];

            this.parameter.inv.ExternalIO_2_Enabled = [];
            this.parameter.inv.ExternalIO_2_PLockIn = [];
            this.parameter.inv.ExternalIO_2_PLockOut = [];
            this.parameter.inv.ExternalIO_2_ActivationTime = [];
            this.parameter.inv.ExternalIO_2_DeactivationTime = [];
            this.parameter.inv.ExternalIO_2_SOCInsteadOfPowerEnabled = [];

            this.parameter.inv.ExternalIO_3_Enabled = [];
            this.parameter.inv.ExternalIO_3_PLockIn = [];
            this.parameter.inv.ExternalIO_3_PLockOut = [];
            this.parameter.inv.ExternalIO_3_ActivationTime = [];
            this.parameter.inv.ExternalIO_3_DeactivationTime = [];
            this.parameter.inv.ExternalIO_3_SOCInsteadOfPowerEnabled = [];

            this.parameter.inv.ExternalIO_4_Enabled = [];
            this.parameter.inv.ExternalIO_4_PLockIn = [];
            this.parameter.inv.ExternalIO_4_PLockOut = [];
            this.parameter.inv.ExternalIO_4_ActivationTime = [];
            this.parameter.inv.ExternalIO_4_DeactivationTime = [];
            this.parameter.inv.ExternalIO_4_SOCInsteadOfPowerEnabled = [];

            this.parameter.inv.Overflows_MaximumReservedPower = [];
            this.parameter.inv.User_Overflows_MaximumReservedPower = [];

            this.parameter.inv.User_SOCLevelForStopCharging = [];

            this.parameter.inv.GeneralConfigBits.OverflowsEnabled = [];
            this.parameter.inv.UserConfigBits.OverflowsEnabled = [];
            this.parameter.inv.UserConfigBits.HigherEnergyManagementEnabled = [];

            this.parameter.inv.SOCLevelForStartCharging = [];
            this.parameter.inv.SOCLevelForStopCharging = [];
            this.parameter.inv.SOCLevelForENOverflows = [];
            this.parameter.inv.SOCLevelForMinPower = [];
            this.parameter.inv.SOCLevelForDisableInverterInOffGrid = [];

            this.sliderValues = [];

            for (let i = 0; i < this.parameters.units.length; i++) {
              if (this.parameters.units[i].type.includes("INV")) {
                for (let j = 0; j < this.parameters.units[i].parameters.length; j++) {
                  if (this.parameters.units[i].parameters[j].name === "Overflows_MaximumReservedPower") {
                    this.parameter.inv.Overflows_MaximumReservedPower.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "User_Overflows_MaximumReservedPower") {
                    this.parameter.inv.User_Overflows_MaximumReservedPower.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }

                  if (this.parameters.units[i].parameters[j].name === "SOCLevelForENOverflows") {
                    this.parameter.inv.SOCLevelForENOverflows.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }

                  if (this.parameters.units[i].parameters[j].name === "SOCLevelForMinPower") {
                    this.parameter.inv.SOCLevelForMinPower.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }

                  if (this.parameters.units[i].parameters[j].name === "SOCLevelForDisableInverterInOffGrid") {
                    this.parameter.inv.SOCLevelForDisableInverterInOffGrid.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }

                  if (this.parameters.units[i].parameters[j].name === "SOCLevelForStartCharging") {
                    this.parameter.inv.SOCLevelForStartCharging.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }

                  if (this.parameters.units[i].parameters[j].name === "SOCLevelForStopCharging") {
                    this.parameter.inv.SOCLevelForStopCharging.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }

                  if (this.parameters.units[i].parameters[j].name === "User_SOCLevelForStopCharging") {
                    this.parameter.inv.User_SOCLevelForStopCharging.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }

                  if (this.parameters.units[i].parameters[j].name === "GeneralConfigBits") {
                    for (let k = 0; k < this.parameters.units[i].parameters[j].bits.length; k++) {
                      if (this.parameters.units[i].parameters[j].bits[k].name === "OverflowsEnabled") {
                        this.parameter.inv.GeneralConfigBits.OverflowsEnabled.push(
                          this.collectParameter(
                            this.parameters.units[i], //
                            this.parameters.units[i].parameters[j], //
                            this.parameters.units[i].parameters[j].bits[k] //
                          )
                        );
                      }
                    }
                  }

                  if (this.parameters.units[i].parameters[j].name === "UserConfigBits") {
                    for (let k = 0; k < this.parameters.units[i].parameters[j].bits.length; k++) {
                      if (this.parameters.units[i].parameters[j].bits[k].name === "UserConfigBits_OverflowsEnabled") {
                        this.parameter.inv.UserConfigBits.OverflowsEnabled.push(
                          this.collectParameter(
                            this.parameters.units[i], //
                            this.parameters.units[i].parameters[j], //
                            this.parameters.units[i].parameters[j].bits[k] //
                          )
                        );
                      }

                      if (this.parameters.units[i].parameters[j].bits[k].name === "UserConfigBits_HigherEnergyManagementEnabled") {
                        this.parameter.inv.UserConfigBits.HigherEnergyManagementEnabled.push(
                          this.collectParameter(
                            this.parameters.units[i], //
                            this.parameters.units[i].parameters[j], //
                            this.parameters.units[i].parameters[j].bits[k] //
                          )
                        );
                      }
                    }
                  }

                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_1_SOCInsteadOfPowerEnabled") {
                    this.parameter.inv.ExternalIO_1_SOCInsteadOfPowerEnabled.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_2_SOCInsteadOfPowerEnabled") {
                    this.parameter.inv.ExternalIO_2_SOCInsteadOfPowerEnabled.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_3_SOCInsteadOfPowerEnabled") {
                    this.parameter.inv.ExternalIO_3_SOCInsteadOfPowerEnabled.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_4_SOCInsteadOfPowerEnabled") {
                    this.parameter.inv.ExternalIO_4_SOCInsteadOfPowerEnabled.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }

                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_1_Enabled") {
                    this.parameter.inv.ExternalIO_1_Enabled.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_1_PLockIn") {
                    this.parameter.inv.ExternalIO_1_PLockIn.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_1_PLockOut") {
                    this.parameter.inv.ExternalIO_1_PLockOut.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_1_ActivationTime") {
                    this.parameter.inv.ExternalIO_1_ActivationTime.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_1_DeactivationTime") {
                    this.parameter.inv.ExternalIO_1_DeactivationTime.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }

                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_2_Enabled") {
                    this.parameter.inv.ExternalIO_2_Enabled.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_2_PLockIn") {
                    this.parameter.inv.ExternalIO_2_PLockIn.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_2_PLockOut") {
                    this.parameter.inv.ExternalIO_2_PLockOut.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_2_ActivationTime") {
                    this.parameter.inv.ExternalIO_2_ActivationTime.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_2_DeactivationTime") {
                    this.parameter.inv.ExternalIO_2_DeactivationTime.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }

                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_3_Enabled") {
                    this.parameter.inv.ExternalIO_3_Enabled.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_3_PLockIn") {
                    this.parameter.inv.ExternalIO_3_PLockIn.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_3_PLockOut") {
                    this.parameter.inv.ExternalIO_3_PLockOut.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_3_ActivationTime") {
                    this.parameter.inv.ExternalIO_3_ActivationTime.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_3_DeactivationTime") {
                    this.parameter.inv.ExternalIO_3_DeactivationTime.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }

                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_4_Enabled") {
                    this.parameter.inv.ExternalIO_4_Enabled.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_4_PLockIn") {
                    this.parameter.inv.ExternalIO_4_PLockIn.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_4_PLockOut") {
                    this.parameter.inv.ExternalIO_4_PLockOut.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_4_ActivationTime") {
                    this.parameter.inv.ExternalIO_4_ActivationTime.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                  if (this.parameters.units[i].parameters[j].name === "ExternalIO_4_DeactivationTime") {
                    this.parameter.inv.ExternalIO_4_DeactivationTime.push(
                      this.collectParameter(
                        this.parameters.units[i], //
                        this.parameters.units[i].parameters[j], //
                        null //
                      )
                    );
                  }
                }
              }
            }

            this.sliderValues = [this.parameter.inv.SOCLevelForStartCharging[0].parameterValue, this.parameter.inv.SOCLevelForStopCharging[0].parameterValue];
          })
          .catch((error) => {
            this.parameters = ServiceClient.handleUnauthorized(error, this.$router);
          });
      },
      pollParameters() {
        this.timerParameters = setInterval(() => {
          this.getParameters();
        }, 2500);
      },
      sendBitValue(item) {
        this.stopTimerParameters();

        if (isNaN(item.bitValue)) {
          return;
        }

        if (item.bitValue === true) {
          item.bitValue = 1;
        }
        if (item.bitValue === false) {
          item.bitValue = 0;
        }

        let parameters = "?" + "unit" + "=" + item.unitAddress + "&" + "par" + "=" + item.parameterName + "&" + "bit" + "=" + item.bitName + "&" + "val" + "=" + item.bitValue;

        ServiceClient.dataCore(ServiceClient.getAPIUrl("parameters"), null, parameters, "GET")
          .then(() => {
            setTimeout(() => {
              this.refreshTimer();
            }, 2000);
          })
          .catch((error) => {
            ServiceClient.handleUnauthorized(error, this.$router);
          });
      },
      sendValueSwitch(item) {
        this.stopTimerParameters();
        this.sendValue(item);
      },
      sendValue(item) {
        if (isNaN(item.parameterValue)) {
          return;
        }

        if (item.parameterValue === true) {
          item.parameterValue = 1;
        }
        if (item.parameterValue === false) {
          item.parameterValue = 0;
        }

        let parameters = "?" + "unit" + "=" + item.unitAddress + "&" + "par" + "=" + item.parameterName + "&" + "val" + "=" + item.parameterValue;

        ServiceClient.dataCore(ServiceClient.getAPIUrl("parameters"), null, parameters, "GET")
          .then(() => {
            setTimeout(() => {
              this.refreshTimer();
            }, 2000);
          })
          .catch((error) => {
            ServiceClient.handleUnauthorized(error, this.$router);
          });
      },

      getLabel(item) {
        let my = "parameters.";

        let myUnit =
          item.unitType == "EINV3H0"
            ? "inverter."
            : item.unitType == "EINV1H0"
            ? "inverter." //
            : item.unitType == "EINV1H1"
            ? "inverter." //
            : item.unitType == "EMPPTH0"
            ? "mppt." //
            : item.unitType == "EMPPTH1"
            ? "mppt." //
            : item.unitType == "EBCU0H0"
            ? "bcu." //
            : item.unitType == "EBATCH0"
            ? "dab." //
            : item.unitType == "EDPBMS1"
            ? "bms." //
            : item.unitType == "XELMET1"
            ? "meter." //
            : item.unitType == "EVCAC02"
            ? "evcac." //
            : item.unitType == "EVCAC01"
            ? "evcac." //
            : item.unitType == "EVCDC01"
            ? "evcdc."
            : 0; //

        let bitName = item.bitName == "" ? "" : "." + item.bitName;

        /* let parameterUnits = item.parameterUnits == "" ? "" : " [" + item.parameterUnits + "]"; */

        let l = this.$i18n.t(my + myUnit + item.parameterName + bitName); /*  + parameterUnits; */

        return l;
      },
      collectParameter(units, unitsParameters, unitsParametersBits) {
        let obj = {};

        obj = {
          unitAddress: units.address,
          unitType: units.type,
          parameterUnits: unitsParameters.units,
          parameterName: unitsParameters.name,
          parameterValue: unitsParameters.value,
          bitName: unitsParametersBits == null ? "" : unitsParametersBits.name,
          bitValue: unitsParametersBits == null ? "" : unitsParametersBits.value,
        };

        return obj;
      },
    },
    beforeDestroy() {
      clearInterval(this.timerMain);
      clearInterval(this.timerExternal);
      clearInterval(this.timerParameters);
    },
    destroyed() {},
  };
</script>

<style scoped>
  .my-border-purple {
    border-left: 5px solid #9c27b0;
    border-right: 5px solid #9c27b0;
    border-radius: 8px;
    /*   box-shadow: 0 0 0 1px #9c27b0; */
  }
  .my-border-blue {
    border-left: 5px solid #2196f3;
    border-right: 5px solid #2196f3;
    border-radius: 8px;
    /*   box-shadow: 0 0 0 1px #2196F3; */
  }
  .my-border-green {
    border-left: 5px solid #4caf50;
    border-right: 5px solid #4caf50;
    border-radius: 8px;
    /*   box-shadow: 0 0 0 1px #4CAF50; */
  }
  .my-border-orange {
    border-left: 5px solid #ff9800;
    border-right: 5px solid #ff9800;
    border-radius: 8px;
    /*   box-shadow: 0 0 0 1px #ff9800; */
  }
</style>
